export const DocumentViewOptions = {
    Data: 'data',
    Document: 'document',
    Form: 'form',
    Pdf: 'pdf',
}
